import React from "react";
import SuggestInputField from "./SuggestInputField";
import Dropdown from "./Dropdown";

/**
 * Renders a field the customer's own values are offered for, constrained to those
 * values or accepting a new one depending on the server-side policy (PBI #292).
 *
 * When there are no existing values to choose from the field always accepts a value of
 * the orderer's own, whatever the policy says — a customer with no users yet
 * (precondition #330) must not be left with an empty, unusable dropdown.
 *
 * Shared by the onboarding form and the edit form (PBI #316), so both offer the same
 * list values for the same fields.
 */
const ListValueField = ({
  label,
  value,
  options,
  allowCustom,
  onChange,
  placeholder,
}) => {
  const hasOptions = options.length > 0;

  if (allowCustom || !hasOptions) {
    return (
      <SuggestInputField
        label={label}
        value={value}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
      />
    );
  }

  return (
    <Dropdown
      label={label}
      value={value || ""}
      options={options}
      onSelect={onChange}
      placeholder={placeholder}
      searchable={options.length > 8}
    />
  );
};

export default ListValueField;
